import type { ToolCatalogEntry } from '../../toolset/types';
import type { GeneratedToolAccess } from '../../toolset/generated/toolCatalog.generated';

/**
 * The allowed_tools entries the step editor offers. Read tools are never restricted on a step,
 * so only tools a step could be refused appear: write-level tools, and the mode tools, whose
 * read-level catalog entry hides a write or automation mode. A mode tool is offered once per
 * mode, its plain name standing for the least. Escalation tools never appear: a workflow never
 * changes an operator's access.
 */
export const workflowToolOptions = (catalog: (ToolCatalogEntry & GeneratedToolAccess)[]): string[] =>
  catalog
    .filter((t) => !t.escalation)
    .filter((t) => t.level !== 'read' || t.accessModes)
    .sort((a, b) => (a.name < b.name ? -1 : a.name > b.name ? 1 : 0))
    .filter((t, i, all) => i === 0 || all[i - 1].name !== t.name)
    .flatMap((t) =>
      t.accessModes
        ? [t.name, ...t.accessModes.modes.filter((m) => m !== t.accessModes?.least).map((m) => `${t.name}:${m}`)]
        : [t.name],
    );
